export const TimeCard = () => {
  return <div>Welcome to Time Card page...........</div>;
};
